import React from 'react';
import PropTypes from 'prop-types';
import { sortOptions } from '../../../helpers';
import { SortByLabel, SortByWrapper } from './SortAndPagination.css';
import { SortBySelector } from './sort_components';

class SortBy extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionClick = this.handleOptionClick.bind(this);
  }

  handleOptionClick({ label, value }) {
    const { handleClick } = this.props;
    handleClick(value, label);
  }

  buildOptionsList() {
    return sortOptions.map(({ label, value }) => (
      <option key={`sort-${value}`} value={value}>
        {label}
      </option>
    ));
  }

  render() {
    const { sortFilterSelect, s3BasePath } = this.props;
    return (
      <SortByWrapper>
        <SortByLabel>Sort by</SortByLabel>
        <SortBySelector
          s3BasePath={s3BasePath}
          onSelect={this.handleOptionClick}
          options={sortOptions}
          sortFilterSelect={sortFilterSelect}
        />
      </SortByWrapper>
    );
  }
}

SortBy.propTypes = {
  handleClick: PropTypes.func.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  sortFilterSelect: PropTypes.string.isRequired,
};

export default SortBy;
